// Thư mục: src/services/xePhanCongService.js
import api from "@/api";

// Endpoint gốc cho API phân công xe
const base = "/api/xe-assignments";

/**
 * API service cho Quản lý Phân Công Xe
 */
export const XePhanCongApi = {
  getAssigned() {
    return api.get(`${base}/list-assigned`).then((res) => res.data);
  },
  // Đổi tên thành object export cho nhất quán
  /**
   * Tạo phân công mới (Lệnh Giao Xe)
   * @param {object} payload - { xeId, taiXeId, loai ('FIXED'|'TEMP'), lyDo?, startAt?, endAt? }
   * @returns {Promise<object>} DTO XePhanCongDto
   */
  createAssignment(payload) {
    return api.post(base, payload).then((res) => res.data);
  },

  /**
   * Bàn giao xe khẩn cấp (Lệnh Điều Động)
   * @param {number} xeId - ID xe cần bàn giao
   * @param {number} toTaiXeId - ID tài xế mới nhận
   * @param {string} [lyDo] - Lý do bàn giao (tùy chọn)
   * @returns {Promise<object>} DTO XePhanCongDto (của lệnh TEMP mới)
   */
  handover(xeId, toTaiXeId, lyDo) {
    // Dùng query params thay vì URLSearchParams cho gọn
    const params = { xeId, toTaiXeId };
    if (lyDo) {
      params.lyDo = lyDo;
    }
    return api
      .post(`${base}/handover`, null, { params })
      .then((res) => res.data); // Gửi params
  },

  /**
   * Admin kết thúc một lệnh giao xe (Lệnh Trả Xe của Admin)
   * @param {number} assignmentId - ID của XePhanCong cần kết thúc
   * @param {string} [lyDo] - Lý do kết thúc (tùy chọn)
   * @returns {Promise<void>} Thường trả về 204 No Content
   */
  closeAssignment(assignmentId, lyDo) {
    const params = {};
    if (lyDo) {
      params.lyDo = lyDo;
    }
    // Gọi API POST /api/xe-assignments/{id}/close
    return api
      .post(`${base}/${assignmentId}/close`, null, { params })
      .then((res) => res.data);
  },

  /**
   * Tài xế thực hiện Nhận/Trả xe
   * @param {object} payload - { phanCongId, eventType: 'RECEIVE'|'RETURN', odo?, mucNhienLieu?, ghiChu? }
   * @returns {Promise<void>} Thường trả về 204 No Content
   */
  postEvent(payload) {
    return api.post(`${base}/events`, payload).then((res) => res.data);
  },

  /**
   * Lấy phân công active hiện tại theo ID Xe
   * @param {number} xeId - ID Xe
   * @returns {Promise<object|null>} DTO XePhanCongDto hoặc null nếu không có
   */
  getCurrentByXe(xeId) {
    return api.get(`${base}/current/by-xe/${xeId}`).then((res) => res.data);
  },

  /**
   * Lấy lịch sử phân công theo ID Xe
   * @param {number} xeId - ID Xe
   * @returns {Promise<Array<object>>} List XePhanCongDto
   */
  historyByXe(xeId) {
    return api.get(`${base}/history/by-xe/${xeId}`).then((res) => res.data);
  },

  /**
   * Lấy phân công active hiện tại của tài xế đang đăng nhập
   * @returns {Promise<object|null>} DTO XePhanCongDto hoặc null nếu không có
   */
  myCurrent() {
    return api.get(`${base}/me/current`).then((res) => res.data);
  },

  /**
   * Lấy lịch sử phân công theo ID Tài xế (Người dùng)
   * @param {number} taiXeId - ID Người dùng (tài xế)
   * @returns {Promise<Array<object>>} List XePhanCongDto
   */
  historyByDriver(taiXeId) {
    return api
      .get(`${base}/history/by-driver/${taiXeId}`)
      .then((res) => res.data);
  },

  // --- Hàm gọi API Người dùng ---
  // (Để tìm tài xế cho modal, nên tách ra nguoiDungService.js)

  /**
   * Lấy danh sách người dùng theo mã chức vụ (ví dụ: TAI_XE)
   * @param {string} maChucVu - Mã chức vụ cần lọc
   * @returns {Promise<Array<object>>} List NguoiDungResponse (đã rút gọn)
   */
  usersByChucVuCode(maChucVu) {
    // Gọi API đã tạo ở NguoiDungController
    return api
      .get(`/api/nguoi-dung/by-chuc-vu-code/${encodeURIComponent(maChucVu)}`)
      .then((res) => res.data);
  },

  /**
   * (Tùy chọn) Lấy gợi ý người dùng theo tên/username
   * @param {string} q - Từ khóa tìm kiếm
   * @param {number} limit - Số lượng tối đa
   * @returns {Promise<Array<object>>} List user options
   */
  userOptions(q = "", limit = 50) {
    // API này có thể khác tùy backend của em
    return api
      .get(`/api/nguoi-dung/options`, { params: { q, limit } })
      .then((res) => res.data);
  },

  usersByPhongBanCode(maPhongBan) {
    return api.get(
      `/api/nguoi-dung/by-phong-ban-code/${encodeURIComponent(maPhongBan)}`
    );
  },

  byPhanCong(pcId) {
    return api.get(`${base}/phan-cong/${pcId}`).then((r) => r.data);
  },
  // myCurrent() {
  //   return api.get(`${base}/me`).then((r) => r.data);
  // },
};
